
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#customerFilled_svg__clip0_310_1625)"}},[_c('path',{attrs:{"d":"M9.04 21.104c-2.496 0-4.522-2.698-4.522-6.028 0-3.025 1.669-5.529 3.846-5.961C10.413 3.807 16.012 0 22.605 0c6.589 0 12.193 3.807 14.242 9.11 2.177.433 3.846 2.941 3.846 5.962 0 3.33-2.027 6.027-4.522 6.027h-1.506v-7.533c0-5.75-5.334-10.55-12.06-10.55-6.725 0-12.06 4.8-12.06 10.55v7.538H9.04zM1.584 45.219a12.246 12.246 0 01-.084-1.505c0-6.633 4.165-12.431 10.378-15.58a17.997 17.997 0 0010.726 3.52 18.027 18.027 0 0010.727-3.52c6.209 3.149 10.377 8.947 10.377 15.58 0 .552-.03 1.055-.084 1.505H1.585zm21.02-18.087c-5.829 0-10.55-4.725-10.55-10.55 0-5.83 4.726-10.55 10.55-10.55 5.83 0 10.55 4.725 10.55 10.55 0 5.825-4.725 10.55-10.55 10.55z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"customerFilled_svg__clip0_310_1625"}},[_c('rect',{attrs:{"width":"45.219","height":"45.219","fill":"#fff"}})])])])
          )
        }
      }
    